export default __webpack_public_path__ + "static/media/neon_cassette_player.9cfafca3.svg";